<template>

    <a class='gallery-trigger' @click='openModal'>
        <svg width='42' height='42' viewBox='0 0 42 42' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='21' cy='21' r='20.4' stroke-width='1' vector-effect='non-scaling-stroke' />
            <path d='M13 17V13M13 13H17M13 13L18 18M29 17V13M29 13H25M29 13L24 18M13 25V29M13 29H17M13 29L18 24M29 29L24 24M29 29V25M29 29H25' stroke-linecap='round' stroke-linejoin='round' vector-effect='non-scaling-stroke' />
        </svg>
    </a>

    <Modal ref='modal'>
        <div class='gallery'>
            <div class='gallery__media' :class='{"gallery__media--no-caption": !displayCaption}'>
                <Media
                    :type='type'
                    :url='url'
                    :srcset='srcset'
                    :extension='extension'
                    :width='width'
                    :height='height'
                    :objFit='objFit'
                    :objPosition='objPosition'
                    :alt='alt'
                    :inlineSvg='inlineSvg'
                    :displayCaption='displayCaption'
                />
            </div>

            <div v-if='displayCaption' class='gallery__footer'>
                <div class='gallery__footer__caption' v-text='displayCaption' />
            </div>
        </div>
    </Modal>

</template>


<script>
import Media from '@/components/elements/Media.vue';
import Modal from '@/components/modules/Modal.vue';

export default {
    name: 'Gallery',
    props: {
        type: String,
        url: String,
        srcset: String,
        extension: String,
        width: String,
        height: String,
        objFit: String,
        objPosition: String,
        alt: String,
        inlineSvg: String,
        displayCaption: String
    },
    methods: {
        openModal () {
            this.$refs.modal.openModal();
        }
    },
    components: {
        Media,
        Modal
    }
};
</script>